import { LegalLayout } from "@/components/legal/LegalLayout";
import { LegalP, LegalSection, LegalUl } from "@/components/legal/LegalProse";
import { OperatorContact } from "@/components/legal/OperatorContact";
import { OPERATOR } from "@/lib/legal";
import { tw } from "@/lib/theme";

export function AboutPage() {
  return (
    <LegalLayout
      title={`About ${OPERATOR.product}`}
      subtitle="Photo-first social, built in India."
    >
      <LegalSection title="Mission">
        <LegalP>
          {OPERATOR.product} helps close friends and creators share real moments—photos, short
          Drifts, and Parallel collabs—without the noise of algorithm-only networks. Contact sync
          and audience controls put you in charge of who sees your world.
        </LegalP>
      </LegalSection>

      <LegalSection title="What you can do">
        <LegalUl
          items={[
            "Frames — photo posts with captions and vibes.",
            "Drifts — short vertical video in a swipe feed.",
            "Parallel — real-time co-capture with friends.",
            "Chat — direct and group messaging.",
            "Creator support — tips, subscriptions, and paid unlocks in INR.",
            "Sparks — rewards for growing the community.",
          ]}
        />
      </LegalSection>

      <LegalSection title="Built for India">
        <LegalP>
          UPI-ready payments via Cashfree, regional languages in the Android app, and privacy
          practices aligned with the DPDP Act. Media is served from Cloudflare CDN for fast loads
          across the country.
        </LegalP>
      </LegalSection>

      <LegalSection title="Operator">
        <LegalP>
          {OPERATOR.product} is operated by <strong>{OPERATOR.name}</strong> from Kadapa,
          Andhra Pradesh.
        </LegalP>
        <OperatorContact />
      </LegalSection>

      <LegalSection title="Get the app">
        <LegalP>
          <a
            href={`https://play.google.com/store/apps/details?id=com.dhrudhew.daywia`}
            className={tw.link}
            target="_blank"
            rel="noopener noreferrer"
          >
            Download on Google Play
          </a>{" "}
          — the Android app is the only way to sign in and use {OPERATOR.product}.
        </LegalP>
      </LegalSection>
    </LegalLayout>
  );
}
